export default {
  MAKO_AUTH: 'mako_auth_token',
  CJ_DETAILS: 'cj_details',
  SF_DETAILS: 'sf_details',
  SIGNUP_SESSION: 'signup_session_token',
  SENDGRID_PARTNER: 'sendgrid_partner',
  SELECTED_PACKAGES: 'signUpVals',
  USER_OCCUPATION: 'sg_signup_user_occupation',
};



// WEBPACK FOOTER //
// ./src/constants/cookies.js